export const enum DisplayType {
	PRIMARY = 'primary',
	SECONDARY = 'secondary'
}